import createIcon from '../../createIcon';

/**
 * @component @name CallMissedOutgoing
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMyA4LjIwNDkyTDEyIDE3LjIwNDlMMTkgMTAuMjA0OVYxNC43OTQ5SDIxVjYuNzk0OTJIMTNWOC43OTQ5MkgxNy41OUwxMiAxNC4zODQ5TDQuNDEgNi43OTQ5MkwzIDguMjA0OTJaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const CallMissedOutgoing = createIcon('CallMissedOutgoing', [
  [
    'path',
    {
      d: 'M3 8.20492L12 17.2049L19 10.2049V14.7949H21V6.79492H13V8.79492H17.59L12 14.3849L4.41 6.79492L3 8.20492Z',
      key: 'm0jafq',
    },
  ],
]);

export default CallMissedOutgoing;
